import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/firebaseConfig';

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userDocRef = doc(db, 'users', user.uid);
          const userDocSnap = await getDoc(userDocRef);

          if (userDocSnap.exists()) {
            const role = userDocSnap.data().role;

            if (role === 'user') {
              navigate('/user-dashboard');
            } else if (role === 'security') {
              navigate('/security-dashboard');
            } else if (role === 'admin') {
              navigate('/admin-dashboard');
            } else {
              alert('Unknown role. Please contact support.');
            }
          } else {
            alert('User record not found.');
          }
        } catch (err) {
          console.error('Error fetching user role:', err);
          alert('Failed to load user data.');
        }
      } else {
        navigate('/login');
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  return (
    <div>
      {loading ? <p>Loading dashboard...</p> : <p>Redirecting...</p>}
    </div>
  );
};

export default Dashboard;
